import React, {Component} from 'react';
import VideoContainer from "../../utils/VideoContainer";

class VideoSmall extends Component {

    constructor(props) {

        super(props);

        this.state = {};

    }

    getItems() {

        if (this.props.videoList.length > 0) {
            return this.props.videoList.map(
                (v) => <VideoContainer key={'video-' + v.videoId}
                                       videoId={v.videoId}
                                       videoTitle={v.videoTitle}
                                       videoLength={v.videoLength}
                                       videoDisabled={(v.videoDisabled === 'true')}
                                       videoSource={this.props.source}
                                       classes={'col-lg-2'}
                                       onClick={this.props.onClick}
                />
            );
        }

        return 'No Videos found!';

    }

    render() {

        let items = this.getItems();

        return items;

    }

}

export default VideoSmall;